<template>
  <div v-loading="(!accountDeletion || loading) && !error">
    <card v-if="accountDeletion">
      <h4 slot="header" class="card-title">{{ $t('accountDelete.deletedView.title') }}</h4>
      <template>
        <account-deletion-details :details="accountDeletion" />
      </template>
    </card>
  </div>
</template>
<script>
  import {mapActions, mapState} from "vuex";
  import AccountDeletionDetails from "src/components/AccountDeletion/AccountDeletionDetails";

  export default {
    name: "AccountDeleted",
    components: {
      AccountDeletionDetails
    },
    props: {
      accountId: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapState({
        loading: state => state.account_deletion.loading,
        error: state => state.account_deletion.error,
        accountDeletion: state => state.account_deletion.data,
      }),
    },
    methods: {
      ...mapActions(['GetAccountDeletion']),
    },
    mounted() {
      this.GetAccountDeletion(this.accountId)
    }

  };
</script>
<style></style>
